const OpposingPitchers = {
    OPPOSING_PITCHERS_SET_DATA_FROM_STORAGE: 'OPPOSING_PITCHERS_SET_DATA_FROM_STORAGE',
    OPPOSING_PITCHERS_SET_IS_ALLOWED: 'OPPOSING_PITCHERS_SET_IS_ALLOWED',
    OPPOSING_PITCHERS_SET_ALLOWED_QUANTITY: 'OPPOSING_PITCHERS_SET_ALLOWED_QUANTITY',
};

export default OpposingPitchers;
